export default {
  bind(el, binding, vnode) {
    const { enabled = true, callback } = binding.value || {};

    el.isClickOutsideEnabled = enabled;
    el.clickOutsideCallback = callback;
    el.shouldIgnoreNextClick = false;

    el.clickOutsideHandler = (event) => {
      if (el.isClickOutsideEnabled && !el.shouldIgnoreNextClick) {
        if (!(el === event.target || el.contains(event.target))) {
          if (el.clickOutsideCallback) {
            el.clickOutsideCallback(event);
          }
        }
      } else {
        el.shouldIgnoreNextClick = false; // Сбрасываем флаг после первого пропуска
      }
    };

    document.addEventListener("click", el.clickOutsideHandler);
  },
  update(el, binding, vnode) {
    const { enabled = true, callback } = binding.value || {};

    // Проверяем изменение состояния isEnabled
    if (el.isClickOutsideEnabled !== enabled) {
      el.isClickOutsideEnabled = enabled;

      if (enabled) {
        // Пропускаем первый клик после активации
        vnode.context.$nextTick(() => {
          el.shouldIgnoreNextClick = true;
        });
      }
    }

    el.clickOutsideCallback = callback;
  },
  unbind(el) {
    document.removeEventListener("click", el.clickOutsideHandler);
    el.clickOutsideHandler = null;
    el.clickOutsideCallback = null;
  },
};
